import provider_logo_1 from 'src/assets/img/provider-logos/1.png';
import provider_logo_11 from 'src/assets/img/provider-logos/11.png';
import provider_logo_12 from 'src/assets/img/provider-logos/12.png';
import provider_logo_13 from 'src/assets/img/provider-logos/13.png';
import provider_logo_14 from 'src/assets/img/provider-logos/14.png';
import provider_logo_15 from 'src/assets/img/provider-logos/15.png';
import provider_logo_17 from 'src/assets/img/provider-logos/17.png';
import provider_logo_2 from 'src/assets/img/provider-logos/2.png';
import provider_logo_225 from 'src/assets/img/provider-logos/225.png';
import provider_logo_291 from 'src/assets/img/provider-logos/291.png';
import provider_logo_293 from 'src/assets/img/provider-logos/293.png';
import provider_logo_3 from 'src/assets/img/provider-logos/3.png';
import provider_logo_4 from 'src/assets/img/provider-logos/4.png';
import provider_logo_5 from 'src/assets/img/provider-logos/5.png';
import provider_logo_50 from 'src/assets/img/provider-logos/50.png';
import provider_logo_52 from 'src/assets/img/provider-logos/52.png';
import provider_logo_54 from 'src/assets/img/provider-logos/54.png';
import provider_logo_56 from 'src/assets/img/provider-logos/56.png';
import provider_logo_57 from 'src/assets/img/provider-logos/57.png';
import provider_logo_58 from 'src/assets/img/provider-logos/58.png';
import provider_logo_59 from 'src/assets/img/provider-logos/59.png';
import provider_logo_6 from 'src/assets/img/provider-logos/6.png';
import provider_logo_7 from 'src/assets/img/provider-logos/7.png';
import provider_logo_9 from 'src/assets/img/provider-logos/9.png';
import provider_logo_91 from 'src/assets/img/provider-logos/91.png';

export const ProviderLogosById: Record<string, string> = {
  '1': provider_logo_1,
  '2': provider_logo_2,
  '3': provider_logo_3,
  '4': provider_logo_4,
  '5': provider_logo_5,
  '6': provider_logo_6,
  '7': provider_logo_7,
  '9': provider_logo_9,
  '11': provider_logo_11,
  '12': provider_logo_12,
  '13': provider_logo_13,
  '14': provider_logo_14,
  '15': provider_logo_15,
  '17': provider_logo_17,
  '50': provider_logo_50,
  '52': provider_logo_52,
  '54': provider_logo_54,
  '56': provider_logo_56,
  '57': provider_logo_57,
  '58': provider_logo_58,
  '59': provider_logo_59,
  '91': provider_logo_91,
  '225': provider_logo_225,
  '291': provider_logo_291,
  '293': provider_logo_293,
};
